module.exports = __webpack_public_path__ + "files/cac4e83d6ca840fe5ea4d5cc194c97b8.png";